export enum BaseCurrency {
  HKD = 'HKD',
  USD = 'USD'
}

export enum Vendor {
  utgl = 'UTGL',
  fga = 'FGA',
  gbf = 'GBF'
}
